import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import solar from "./img/services-solar.png"
import electrical from "./img/electrical.jpg"
import hvac from "./img/hvac.jpeg"
import cctvhkvision from "./img/cctvhkvision.png"
import cctvaudio from "./img/cctvaudio.png"
import inverter from "./img/inverter.png";
import solar2 from "./img/solar-service2.png";
import hvac2 from "./img/hvac2.png";
import hvac3 from "./img/hvac3.png";
import cctv1 from "./img/cctv-serivices.png";
import cctv2 from "./img/cctv-service1.png";
import { X, ChevronRight } from 'lucide-react'

const serviceCategories = [
  {
    id: 1,
    title: "Solar Technologies",
    image: solar,
    galleryImages: [solar, inverter, solar2],
    description: "Go green and harness the power of the sun with our comprehensive solar solutions. From residential panels to commercial installations, we provide cutting-edge technology for sustainable energy.",
    subServices: [
      {
        id: 11,
        name: "Solar panels (PV kits)",
        description: "Complete photovoltaic kits for residential and commercial use",
        redirect: "/pricing#solar"
      },
      {
        id: 12,
        name: "Solar street lights",
        description: "Energy-efficient lighting solutions for streets and pathways",
        redirect: "/pricing#solar"
      },
      {
        id: 13,
        name: "Solar water heating",
        description: "Eco-friendly water heating systems powered by solar energy",
        redirect: "/pricing#heating"
      },
      {
        id: 14,
        name: "Solar water pumping",
        description: "Reliable water pumping solutions for remote areas and irrigation",
        redirect: "/pricing#pumps"
      }
    ]
  },
  {
    id: 2,
    title: "CCTV Cameras",
    image: cctv1,
    galleryImages: [cctvhkvision, cctvaudio, cctv1, cctv2],
    description: "Enhance the security of your property with our comprehensive CCTV solutions. From hidden surveillance to advanced IP cameras, we provide cutting-edge security systems.",
    subServices: [
      {
        id: 21,
        name: "Spy/hidden cameras",
        description: "Discreet surveillance solutions for covert monitoring",
        redirect: "/pricing#cctv"
      },
      {
        id: 22,
        name: "Solar PTZ stand-alone cameras",
        description: "Self-powered pan-tilt-zoom cameras for remote locations",
        redirect: "/pricing#cctv"
      },
      {
        id: 23,
        name: "IP cameras",
        description: "Network-based cameras for digital surveillance systems",
        redirect: "/pricing#cctv"
      },
      {
        id: 24,
        name: "PTZ stand-alone cameras",
        description: "Professional pan-tilt-zoom cameras for comprehensive coverage",
        redirect: "/pricing#cctv"
      }
    ]
  },
  {
    id: 3,
    title: "Electrical",
    image: electrical,
    description: "Complete electrical solutions for residential and commercial properties. From basic wiring to complex installations, we ensure safety and efficiency.",
    subServices: [
      {
        id: 31,
        name: "Piping & wiring",
        description: "Professional electrical piping and wiring installations",
        redirect: "/#"
      },
      {
        id: 32,
        name: "Panel upgrades",
        description: "Electrical panel upgrades for improved safety and capacity",
        redirect: "/#"
      },
      {
        id: 33,
        name: "Instant shower installation",
        description: "Quick and efficient electric shower installations",
        redirect: "/#"
      },
      {
        id: 34,
        name: "Repairs and maintenance",
        description: "Comprehensive electrical repair and maintenance services",
        redirect: "/#"
      }
    ]
  },
  {
    id: 4,
    title: "HVAC",
    image: hvac,
    galleryImages: [hvac, hvac2, hvac3],
    description: "Complete heating, ventilation, and air conditioning solutions. We provide comfort and climate control for all types of properties.",
    subServices: [
      {
        id: 41,
        name: "Air conditioning installation and servicing",
        description: "Professional AC installation and maintenance services",
        redirect: "/pricing#hvac"
      },
      {
        id: 42,
        name: "Heating systems",
        description: "Efficient heating solutions for residential and commercial spaces",
        redirect: "/pricing#hvac"
      },
      {
        id: 43,
        name: "Ventilation solutions",
        description: "Proper ventilation systems for improved air quality",
        redirect: "/pricing#hvac"
      }
    ]
  }
]

const ServiceModal = ({ isOpen, onClose, service }) => {
  const navigate = useNavigate();
  if (!isOpen || !service) return null

  const handleSubServiceClick = (subService) => {
    navigate(subService.redirect)
  }

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        <div className="sticky top-0 bg-white border-b border-gray-100 p-6 flex justify-between items-center">
          <h2 className="text-xl font-bold" style={{ color: '#712B35' }}>{service.title}</h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl hover:bg-gray-100 transition-all duration-200 flex items-center justify-center"
          >
            <X size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-52 object-cover rounded-xl mb-6"
          />

          <p className="text-gray-600 mb-6 leading-relaxed text-sm">{service.description}</p>

          <h3 className="text-base font-semibold mb-3" style={{ color: '#712B35' }}>Our Services Include:</h3>

          <div className="space-y-3">
            {service.subServices.map((subService) => (
              <div
                key={subService.id}
                onClick={() => handleSubServiceClick(subService)}
                className="p-5 border border-gray-200 rounded-xl hover:text-white cursor-pointer transition-all duration-300 group"
                style={{ borderColor: '#e5e7eb' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#712B35';
                  e.currentTarget.style.borderColor = '#712B35';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '';
                  e.currentTarget.style.borderColor = '#e5e7eb';
                }}
              >
                <div className="flex justify-between items-start mb-1">
                  <h4 className="font-semibold text-sm group-hover:text-white transition-colors">{subService.name}</h4>
                  <ChevronRight size={16} className="group-hover:text-white transition-colors" style={{ color: '#712B35' }} />
                </div>
                <p className="text-sm text-gray-500 group-hover:text-gray-200 transition-colors">
                  {subService.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const ServiceCard = ({ service, onClick }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const images = service.galleryImages || [service.image]

  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        )
      }, 3000)
      return () => clearInterval(interval)
    }
  }, [images.length])

  return (
    <div
      onClick={onClick}
      className="group bg-white rounded-2xl overflow-hidden transition-all duration-500 cursor-pointer border border-gray-100 hover:shadow-2xl hover:-translate-y-1"
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#712B35';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '#e5e7eb';
      }}
    >
      <div className="relative h-52 overflow-hidden">
        {images.map((image, index) => (
          <img
            key={index}
            alt={`${service.title} service`}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-500 group-hover:scale-105 ${index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`}
            src={image}
            loading="lazy"
          />
        ))}
        {images.length > 1 && (
          <div className="absolute bottom-3 left-0 right-0 flex justify-center space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={(e) => {
                  e.stopPropagation()
                  setCurrentImageIndex(index)
                }}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'bg-white w-4' 
                    : 'bg-white/50 hover:bg-white/80'
                }`}
              />
            ))}
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <div className="p-6">
        <h3 className="font-bold text-lg mb-1 transition-colors duration-300 group-hover:text-[#712B35]">
          {service.title}
        </h3>
        <p className="text-gray-500 text-sm leading-relaxed line-clamp-3">
          {service.description}
        </p>
        <div className="mt-4 pt-4 border-t border-gray-100">
          <span className="text-sm font-medium flex items-center gap-1.5 transition-colors duration-300 group-hover:text-[#712B35]">
            Explore services
            <ChevronRight size={14} className="transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </div>
    </div>
  )
}

function Another() {
  const [selectedService, setSelectedService] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleServiceClick = (service) => {
    setSelectedService(service)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedService(null)
  }

  return (
    <div>
      <section id="services" className="py-24 md:py-32 px-6 md:px-10" style={{ background: '#fafafa' }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase" style={{ color: '#712B35' }}>
              What We Do
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-3" style={{ color: '#2a2118' }}>
              Our Services
            </h2>
            <p className="text-base max-w-2xl mx-auto font-light" style={{ color: '#5a524c' }}>
              We are deeply committed to the growth and success of our clients.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {serviceCategories.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                onClick={() => handleServiceClick(service)}
              />
            ))}
          </div>
        </div>
      </section>

      <ServiceModal
        isOpen={isModalOpen}
        onClose={closeModal}
        service={selectedService}
      />
    </div>
  )
}

export default Another
